import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { legalApi } from '../lib/reportsApi';
import { PageHeader, SectionCard } from '../components/ui/light';

export default function LegalPage() {
  const { kind } = useParams();
  const navigate = useNavigate();
  const [doc, setDoc] = useState<{ title: string; body_markdown: string; version: string } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (kind !== 'terms' && kind !== 'privacy') return;
    legalApi.current().then((r) => {
      const v = kind === 'terms' ? r.data.terms_version : r.data.privacy_version;
      const t = kind === 'terms' ? r.data.terms_title   : r.data.privacy_title;
      legalApi.document(kind, v)
        .then((d) => setDoc({ title: t, body_markdown: d.data.body_markdown, version: v }))
        .finally(() => setLoading(false));
    }).catch(() => setLoading(false));
  }, [kind]);

  if (loading) {
    return (
      <div className="theme-light l-page min-h-screen flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: 'var(--ch2-accent)' }} />
      </div>
    );
  }
  if (!doc) {
    return (
      <div className="theme-light l-page min-h-screen p-10">
        <div className="l-shell">Document not available.</div>
      </div>
    );
  }
  return (
    <div className="theme-light l-page min-h-screen">
      <div className="l-shell py-10 max-w-3xl">
        <PageHeader
          eyebrow={`Version ${doc.version}`}
          title={doc.title}
          back={{ label: 'Back', onClick: () => navigate(-1) }}
        />
        <SectionCard variant="elevated">
          <div className="prose prose-sm max-w-none whitespace-pre-wrap" style={{ color: 'var(--ch2-ink)' }}>
            {doc.body_markdown}
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
